import { contractsDictionaryAPI } from "./api";

export const getContracts1cStatus = async (params) => {
  const res = await contractsDictionaryAPI.read1cStatus(params);
  if (!res) return null;
  return { data: res.data, total_count: res.total_count || 0 };
};

export const getResidentsForSelect = async () => {
  const res = await contractsDictionaryAPI.readResidents();
  if (!res) return null;
  return res.data;
};

export const getContractorsForSelect = async () => {
  const res = await contractsDictionaryAPI.readContractors();
  if (!res) return null;
  return res.data;
};

export const SEND_STATUS_OPTIONS = [
  { value: "SUCCESS", label: "Успешно отправлен" },
  { value: "ERROR", label: "Ошибка" },
  { value: "NOT_SENT", label: "Не отправлен" },
];

export const SEND_STATUS_MAP = {
  SUCCESS: { label: "Успешно отправлен", color: "positive" },
  ERROR: { label: "Ошибка", color: "negative" },
  NOT_SENT: { label: "Не отправлен", color: "grey" },
};

export const contracts1cStatusColumns = [
  {
    name: "contractor_agreement_list_id",
    field: "contractor_agreement_list_id",
    label: "Id договора",
    align: "center",
    sortable: true,
    style: "width: 100px",
  },
  {
    name: "agreement_num",
    field: "agreement_num",
    label: "Договор",
    align: "left",
    sortable: true,
    style: "min-width: 160px",
  },
  {
    name: "document_date",
    field: "document_date",
    label: "Дата договора",
    align: "center",
    sortable: true,
    style: "width: 140px",
  },
  {
    name: "contractor_name",
    field: "contractor_name",
    label: "Контрагент",
    align: "left",
    sortable: true,
    style: "min-width: 160px",
  },
  {
    name: "resident_name",
    field: "resident_name",
    label: "ЖК",
    align: "left",
    sortable: true,
    style: "min-width: 140px",
  },
  {
    name: "project_type_name",
    field: "project_type_name",
    label: "Тип проекта",
    align: "left",
    sortable: true,
    style: "min-width: 140px",
  },
  {
    name: "project_name",
    field: "project_name",
    label: "Адрес",
    align: "left",
    sortable: true,
    style: "min-width: 200px",
  },
  {
    name: "agreement_sum",
    field: "agreement_sum",
    label: "Сумма",
    align: "right",
    sortable: true,
    style: "width: 220px; min-width: 200px",
  },
  {
    name: "send_status_name",
    field: "send_status_name",
    label: "Статус отправки",
    align: "center",
    sortable: true,
    style: "width: 150px",
  },
  {
    name: "status_datetime",
    field: "status_datetime",
    label: "Время статуса",
    align: "center",
    sortable: true,
    style: "width: 150px",
  },
  {
    name: "error_text",
    field: "error_text",
    label: "Текст ошибки",
    align: "left",
    sortable: false,
    style: "min-width: 200px",
  },
];
